import React from "react";
import { message } from "antd";

import PaginationBase from "../../../common/base/PaginationBase";

import listaPrecioService from "../../../service/administracion/listaPrecioService";
import monedaService from "../../../service/administracion/monedaService";
import tipoListaPrecioService from "../../../service/administracion/tipoListaPrecioService";
import tipoCambioDiarioService from "../../../service/administracion/tipoCambioDiarioService";
import establecimientoService from "../../../service/administracion/establecimientoService";
import auth from "../../../common/utility/auth";
import { PAGINATION, FILTER } from "../../../common/types/paginationType";
import dialog from "../../../common/utility/dialog";
import global from "../../../common/utility/global";
import estadoMock from "../../../common/mock/estadoMock";
import {
  VALIDAR_STOCK,
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
} from "../../../common/types/parametroType";
import { DOLARES_AMERICANOS, SOLES } from "../../../common/types/monedaType";
import {
  IMPORTE_GANANCIA,
  MARGEN_COMERCIAL,
  PRECIO_VENTA,
} from "../../../common/types/tipoListaPrecioType";
import Header from "../../../components/Header";
import Filters from "./Filters";
import ResultList from "./ResultList";
import FormModal from "./FormModal";
import VentaTipoPrecioVentaFormModal from "./VentaTipoPrecioVentaFormModal";
import LogisticaTipoPrecioVentaModal from "./LogisticaTipoPrecioVentaModal";
import LogisticaTipoImporteGananciaFormModal from "./LogisticaTipoImporteGananciaFormModal";
import LogisticaTipoMargenComercialFormModal from "./LogisticaTipoMargenComercialFormModal";
import ReplicarPrecioModal from "./ReplicarPrecioModal";
import CargaMasivaModal from "./CargaMasivaModal";


import { PRODUCTO } from "../../../common/types/tipoProductoType";
export default class Index extends PaginationBase {
  constructor(props) {
    super(props);
    this.props.onSetBreadcrumb();
    this.state = {
      loadingExcel: false,
      loadingPdf: false,
      loadingPrint: false,
      loadingdetalleExcel: false,
      estados: estadoMock.values,
      monedas: [],
      detalle: [],
      filter: {
        nombre: "",
        estado: '',
        ...FILTER,
      },
      pagination: PAGINATION,
      visible: false,
      replicarVisible: false,
      visibleCargaMasiva: false,
      replicarModal: {
        idListaPrecio: 0,
        dataSource: [],
        selectedRowKeys: []
      },
      visibleVentaTipoPrecioVenta: false,
      visibleLogisticaTipoPrecioVenta: false,
      visibleLogisticaTipoImporteGanancia: false,
      visibleLogisticaTipoMargenComercial: false,
      formValues: this.fetchEmptyFormValues(),
      formValuesDetalle: this.fetchEmptyformValuesDetalle(),
    };
  }

  handleClearFilters = () => {
    var filter = {
      nombre: "",
      estado: '',
      ...FILTER,
    };
    this.setState({ filter });
    this._handlePagination(filter);
  };

  handleKeyUpInput = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      const filter = { ...this.state.filter, ...FILTER };
      this._handlePagination(filter);
    }
  };

  handleChange = (property, value) => {
    const filter = { ...this.state.filter, [property]: value };
    this.setState({ filter });
  };

  handleDeleteActive = (values) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response;
      if (values.flag) response = await listaPrecioService.eliminar(values);
      else response = await listaPrecioService.activar(values);

      if (response.status === 200) {
        message.success("Proceso realizado correctamente.");
        this._handlePagination(this.state.filter);
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleExportExcel = async () => {
    this.setState({ loadingExcel: true });
    var response = await listaPrecioService.excel(this.state.filter);
    this.setState({ loadingExcel: false });
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Lista de Precio.xlsx");
  };

  handleExportPdf = async () => {
    this.setState({ loadingPdf: true });
    var response = await listaPrecioService.pdf(this.state.filter);
    this.setState({ loadingPdf: false });
    if (response !== undefined)
      global.dowloadFile(response.data, "Reporte de Lista de Precio.pdf");
  };

  handlePrint = async () => {
    this.setState({ loadingPrint: true });
    var response = await listaPrecioService.pdf(this.state.filter);
    this.setState({ loadingPrint: false });
    if (response !== undefined) {
      var file = window.URL.createObjectURL(response.data);
      var win = window.open(file, "_blank");
      win.focus();
    }
  };

  /******************** FORM MODAL *****************/

  fetchEmptyFormValues = () => {
    return {
      id: 0,
      nombre: "",
      idMoneda: 0,
      monedas: [],
      establecimientos: [],
      tiposListaPrecio: [],
    };
  };

  fetchEmptyformValuesDetalle = () => {
    return {
      id: 0,
      nombre: "",
      idTipoProducto: PRODUCTO,
      detalle: [],
      monedas: [],
      tiposProductos: [],
      fechaStr: global.fetchCurrentDateStr(),
      tipoCambio: 0,
      tipoCambioCompra: 0,
      precioUnitarioIncluyeIGV: false,
      tipoListaPrecio: "",
    };
  };

  handleNew = () => {
    var formValues = this.fetchEmptyFormValues();
    formValues.monedas = this.state.monedas;
    formValues.tiposListaPrecio = this.state.tiposListaPrecio;
    formValues.establecimientos = this.state.establecimientos;
    this.setState({ visible: true, formValues });
  };

  fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
    const filter = (
      tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario
    ).filter((m) => m.idMoneda === idMoneda);
    if (filter.length > 0) return filter[0];
    else return { venta: 0, compra: 0 };
  };

  getTipoCambio = async () => {
    const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(
      global.fetchCurrentDateStr()
    );
    var tipoCambio = this.fetchTipoCambio(
      DOLARES_AMERICANOS,
      tiposCambioDiario
    );
    return tipoCambio;
  };

  handleViewDetalle = async (row) => {
    console.log(row)
    var params = auth.user().parametros;
    var validarStock =
      params.filter((m) => m.abreviatura === VALIDAR_STOCK)[0].valor === "1"
        ? true
        : false;
    var precioUnitarioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;
    var tipoCambio = await this.getTipoCambio();
    const listaPrecio = await listaPrecioService.obtenerPorId(row.id);
    var formValuesDetalle = this.fetchEmptyformValuesDetalle();
    formValuesDetalle.id = row.id;
    formValuesDetalle.precioUnitarioIncluyeIGV = precioUnitarioIncluyeIGV;
    formValuesDetalle.tipoCambio = parseFloat(tipoCambio.venta);
    formValuesDetalle.tipoCambioCompra = parseFloat(tipoCambio.compra);
    formValuesDetalle.monedas = this.state.monedas;
    formValuesDetalle.tiposProductos = this.state.tiposProductos;
    formValuesDetalle.idTipoListaPrecio = listaPrecio.idTipoListaPrecio;
    formValuesDetalle.tipoListaPrecio = row.tipoListaPrecio;

    if (!validarStock && formValuesDetalle.idTipoListaPrecio === PRECIO_VENTA) {
      var detalle = await listaPrecioService.listarDetalleVentasPorTipoPrecioVenta(row.id);
      formValuesDetalle.detalle = detalle;
      this.setState({
        visibleVentaTipoPrecioVenta: true,
        detalle,
        formValuesDetalle,
      });
    } else if (formValuesDetalle.idTipoListaPrecio === MARGEN_COMERCIAL) {
      var detalle =
        await listaPrecioService.listarDetalleLogisticaPorTipoMargenComercial(
          row.id
        );
      formValuesDetalle.detalle = detalle.filter((m) => m.idTipoProducto === PRODUCTO);
      this.setState({
        visibleLogisticaTipoMargenComercial: true,
        detalle,
        formValuesDetalle,
      });
    } else if (formValuesDetalle.idTipoListaPrecio === IMPORTE_GANANCIA) {
      var detalle =
        await listaPrecioService.listarDetalleLogisticaPorTipoImporteGanancia(
          row.id
        );
      formValuesDetalle.detalle = detalle.filter((m) => m.idTipoProducto === PRODUCTO);
      this.setState({
        visibleLogisticaTipoImporteGanancia: true,
        detalle,
        formValuesDetalle,
      });
    } else if (formValuesDetalle.idTipoListaPrecio === PRECIO_VENTA) {
      var detalle =
        await listaPrecioService.listarDetalleLogisticaPorTipoPrecioVenta(
          row.id
        );
      formValuesDetalle.detalle = detalle.filter((m) => m.idTipoProducto === PRODUCTO);
      this.setState({
        visibleLogisticaTipoPrecioVenta: true,
        detalle,
        formValuesDetalle,
      });
    }
  };

  hanleBuscarProductoVentaTipoPrecioVenta = async (value) => {
    const detalleFiltered = this.state.detalle.filter(
      (m) =>
        ["", null, undefined].includes(value) ||
        global
          .formatSearch(m.codigoReferenciaProducto + m.nombreProducto)
          .match(global.formatSearch(value))
    );
    detalleFiltered.forEach((item) => {
      item.edit = false;
      item.editValorUnitarioSoles = false;
      item.editPrecioUnitarioSoles = false;
      item.editValorUnitarioDolares = false;
      item.editPrecioUnitarioDolares = false;
    });

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle: detalleFiltered,
      },
    });
  };

  hanleBuscarProductoLogisticaTipoPrecioVenta = async (value, idTipoProducto) => {
    const detalleFiltered = this.state.detalle.filter(
      (m) =>
        (["", null, undefined].includes(value) ||
          global
            .formatSearch(m.codigoReferenciaProducto + m.nombreProducto)
            .match(global.formatSearch(value))) &&
        m.idTipoProducto === idTipoProducto
    );

    detalleFiltered.forEach((item) => {
      item.edit = false;
      item.editValorUnitarioSoles = false;
      item.editPrecioUnitarioSoles = false;
      item.editValorUnitarioDolares = false;
      item.editPrecioUnitarioDolares = false;
    });

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle: detalleFiltered,
      },
    });
  };

  hanleBuscarProductoLogisticaTipoImporteGanancia = async (value, idTipoProducto) => {
    const detalleFiltered = this.state.detalle.filter(
      (m) =>
        (["", null, undefined].includes(value) ||
          global
            .formatSearch(m.codigoReferenciaProducto + m.nombreProducto)
            .match(global.formatSearch(value))) &&
        m.idTipoProducto === idTipoProducto
    );

    detalleFiltered.forEach((item) => {
      item.edit = false;
      item.editValorUnitarioSoles = false;
      item.editPrecioUnitarioSoles = false;
      item.editValorUnitarioDolares = false;
      item.editPrecioUnitarioDolares = false;
      item.editImporteGananciaSoles = false;
      item.editImporteGananciaDolares = false;
    });

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle: detalleFiltered,
      },
    });
  };

  hanleBuscarProductoLogisticaTipoMargenComercial = async (value, idTipoProducto) => {
    const detalleFiltered = this.state.detalle.filter(
      (m) =>
        (["", null, undefined].includes(value) ||
          global
            .formatSearch(m.codigoReferenciaProducto + m.nombreProducto)
            .match(global.formatSearch(value))) &&
        m.idTipoProducto === idTipoProducto
    );

    detalleFiltered.forEach((item) => {
      item.edit = false;
      item.editValorUnitarioSoles = false;
      item.editPrecioUnitarioSoles = false;
      item.editValorUnitarioDolares = false;
      item.editPrecioUnitarioDolares = false;
    });

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle: detalleFiltered,
      },
    });
  };

  handleEditVentaTipoPrecioVenta = (id, form) => {
    var detalle = [];
    if (id === 0) {
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        producto.edit = false;
        producto.editValorUnitarioSoles = false;
        producto.editPrecioUnitarioSoles = false;
        producto.editValorUnitarioDolares = false;
        producto.editPrecioUnitarioDolares = false;
        detalle.push(producto);
      });
    } else {
      var idMoneda = form.getFieldValue("idMoneda");
      var params = auth.user().parametros;
      var precioUnitarioInclyIGV =
        params.filter(
          (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
        )[0].valor === "1"
          ? true
          : false;
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        if (item.id === id) {
          producto.edit = true;
          if (!precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editValorUnitarioSoles = true;
          } else if (precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editPrecioUnitarioSoles = true;
          } else if (
            !precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editValorUnitarioDolares = true;
          } else if (
            precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editPrecioUnitarioDolares = true;
          }
        }
        detalle.push(producto);
      });
    }

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle,
      },
    });
  };

  handleSaveVentaTipoPrecioVenta = (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response = await listaPrecioService.modificarDetalle(values);
      if (response.status === 200) {
        form.setFieldsValue({ nombre: "" });
        message.success("Modificado correctamente.");
        var detalle = await listaPrecioService.listarDetalleVentasPorTipoPrecioVenta(values.listaPrecioId);
        this.setState({ detalle }, () => {
          this.hanleBuscarProductoVentaTipoPrecioVenta("");
        });
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleEditLogisticaTipoPrecioVenta = (rows, form) => {
    var id = undefined;
    var lote = undefined;

    if (rows == 0) {
      id = 0;
      lote = '';
    } else {
      id = rows.id;
      lote = rows.lote;
    }
    var detalle = [];

    if (id === 0) {
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        producto.edit = false;
        producto.editValorUnitarioSoles = false;
        producto.editPrecioUnitarioSoles = false;
        producto.editValorUnitarioDolares = false;
        producto.editPrecioUnitarioDolares = false;
        detalle.push(producto);
      });
    } else {
      var idMoneda = form.getFieldValue("idMoneda");
      var params = auth.user().parametros;
      var precioUnitarioInclyIGV =
        params.filter(
          (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
        )[0].valor === "1"
          ? true
          : false;
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        if (item.id === id) {
          producto.edit = true;
          if (!precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editValorUnitarioSoles = true;
          } else if (precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editPrecioUnitarioSoles = true;
          } else if (
            !precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editValorUnitarioDolares = true;
          } else if (
            precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editPrecioUnitarioDolares = true;
          }
        }
        detalle.push(producto);
      });
    }

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle,
      },
    });
  };

  handleEditLogisticaTipoImporteGanancia = (rows, form) => {
    var id = undefined;
    var lote = undefined;

    if (rows == 0) {
      id = 0;
      lote = '';
    } else {
      id = rows.id;
      lote = rows.lote;
    }
    var detalle = [];
    if (id === 0) {
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        producto.edit = false;
        producto.editImporteGananciaSoles = false;
        producto.editImporteGananciaDolares = false;
        producto.editValorUnitarioSoles = false;
        producto.editPrecioUnitarioSoles = false;
        producto.editValorUnitarioDolares = false;
        producto.editPrecioUnitarioDolares = false;
        detalle.push(producto);
      });
    } else {
      var idMoneda = form.getFieldValue("idMoneda");
      var params = auth.user().parametros;
      var precioUnitarioInclyIGV =
        params.filter(
          (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
        )[0].valor === "1"
          ? true
          : false;
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        if (item.id === id) {
          producto.edit = true;
          if (idMoneda === SOLES) {
            producto.editImporteGananciaSoles = true;
          } else {
            producto.editImporteGananciaDolares = true;
          }

          if (!precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editValorUnitarioSoles = true;
          } else if (precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editPrecioUnitarioSoles = true;
          } else if (
            !precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editValorUnitarioDolares = true;
          } else if (
            precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editPrecioUnitarioDolares = true;
          }
        }
        detalle.push(producto);
      });
    }

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle,
      },
    });
  };

  handleEditLogisticaTipoMargenComercial = (rows, form) => {
    var id = undefined;
    var lote = undefined;

    if (rows == 0) {
      id = 0;
      lote = '';
    } else {
      id = rows.id;
      lote = rows.lote;
    }
    var detalle = [];
    if (id === 0) {
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        producto.edit = false;
        producto.editValorUnitarioSoles = false;
        producto.editPrecioUnitarioSoles = false;
        producto.editValorUnitarioDolares = false;
        producto.editPrecioUnitarioDolares = false;
        detalle.push(producto);
      });
    } else {
      var idMoneda = form.getFieldValue("idMoneda");
      var params = auth.user().parametros;
      var precioUnitarioInclyIGV =
        params.filter(
          (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
        )[0].valor === "1"
          ? true
          : false;
      this.state.formValuesDetalle.detalle.forEach((item) => {
        var producto = item;
        if (item.id === id) {
          producto.edit = true;
          if (!precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editValorUnitarioSoles = true;
          } else if (precioUnitarioInclyIGV && idMoneda === SOLES) {
            producto.editPrecioUnitarioSoles = true;
          } else if (
            !precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editValorUnitarioDolares = true;
          } else if (
            precioUnitarioInclyIGV &&
            idMoneda === DOLARES_AMERICANOS
          ) {
            producto.editPrecioUnitarioDolares = true;
          }

        }


        detalle.push(producto);
      });
    }

    this.setState({
      formValuesDetalle: {
        ...this.state.formValuesDetalle,
        detalle,
      },
    });
  };

  handleSaveLogisticaTipoPrecioVenta = (values, form) => {
    debugger
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response = await listaPrecioService.modificarDetalle(values);
      if (response.status === 200) {
        form.setFieldsValue({ nombre: "" });
        message.success("Modificado correctamente.");
        var detalle = await listaPrecioService.listarDetalleLogisticaPorTipoPrecioVenta(values.listaPrecioId);
        var idTipoProducto = form.getFieldValue("idTipoProducto");

        this.setState({ detalle: detalle }, () => {
          this.hanleBuscarProductoLogisticaTipoPrecioVenta("", idTipoProducto);
        });
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleSaveLogisticaTipoImporteGanancia = (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response = await listaPrecioService.modificarDetalle(values);
      if (response.status === 200) {
        form.setFieldsValue({ nombre: "" });
        message.success("Modificado correctamente.");
        var detalle =
          await listaPrecioService.listarDetalleLogisticaPorTipoImporteGanancia(
            values.listaPrecioId
          );
        var idTipoProducto = form.getFieldValue("idTipoProducto");

        this.setState({ detalle: detalle }, () => {
          this.hanleBuscarProductoLogisticaTipoPrecioVenta("", idTipoProducto);
        });
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleSaveLogisticaTipoMargenComercial = (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response = await listaPrecioService.modificarDetalle(values);
      if (response.status === 200) {
        form.setFieldsValue({ nombre: "" });
        message.success("Modificado correctamente.");
        var detalle =
          await listaPrecioService.listarDetalleLogisticaPorTipoMargenComercial(
            values.listaPrecioId
          );
        var idTipoProducto = form.getFieldValue("idTipoProducto");

        this.setState({ detalle: detalle }, () => {
          this.hanleBuscarProductoLogisticaTipoPrecioVenta("", idTipoProducto);
        });
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleSaveReplicarPrecio = (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response = await listaPrecioService.replicar(values);
      if (response.status === 200) {
        message.success("Modificado correctamente.");
        this.setState({ replicarVisible: false });
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };


  handleEdit = async (values) => {
    const response = await listaPrecioService.obtenerPorId(values.id);
    if (response !== undefined) {
      this.setState({
        visible: true,
        formValues: {
          id: response.id,
          nombre: response.nombre,
          idMoneda: response.idMoneda,
          idTipoListaPrecio: response.idTipoListaPrecio,
          idEstablecimiento: response.idEstablecimiento,
          monedas: this.state.monedas,
          tiposListaPrecio: this.state.tiposListaPrecio,
          establecimientos: this.state.establecimientos,
        },
      });
    }
  };

  handleReplicar = async (values) => {
    const response = await listaPrecioService.listarReplicas(values.id);
    if (response !== undefined) {
      this.setState({
        replicarVisible: true,
        replicarModal: {
          dataSource: response,
          idListaPrecio: values.id,
          selectedRowKeys: []
        },
      });
    }
  };

  handleChangeSelectedRowKey = (selected, rows) => {
    this.setState({
      replicarModal: {
        ...this.state.replicarModal,
        selectedRowKeys: selected
      }
    });
  };

  handleExcelDetalle = async (row) => {
    this.setState({
      loadingdetalleExcel: true
    })
    var params = auth.user().parametros;
    var validarStock = params.filter((m) => m.abreviatura === VALIDAR_STOCK)[0].valor === "1" ? true : false;
    var precioUnitarioIncluyeIGV = params.filter(
      (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1" ? true : false;

    const listaPrecio = await listaPrecioService.obtenerPorId(row.id);

    var formValuesDetalle = this.fetchEmptyformValuesDetalle();
    formValuesDetalle.id = row.id;
    formValuesDetalle.precioUnitarioIncluyeIGV = precioUnitarioIncluyeIGV;

    formValuesDetalle.monedas = this.state.monedas;
    formValuesDetalle.tiposProductos = this.state.tiposProductos;
    formValuesDetalle.idTipoListaPrecio = listaPrecio.idTipoListaPrecio;
    formValuesDetalle.tipoListaPrecio = row.tipoListaPrecio;

    if (!validarStock && formValuesDetalle.idTipoListaPrecio === PRECIO_VENTA) {
      var detalle = await listaPrecioService.listarDetalleVentasPorTipoPrecioVenta(row.id);
      formValuesDetalle.detalle = detalle;

    }
    else if (formValuesDetalle.idTipoListaPrecio === MARGEN_COMERCIAL) {
      var response = await listaPrecioService.detalle_ExportarTipoMargenComercial(row.id);
      if (response !== undefined)
        global.dowloadFile(response.data, "Reporte de Lista de Precio Margen Comercial.xlsx");
    }
    else if (formValuesDetalle.idTipoListaPrecio === IMPORTE_GANANCIA) {
      var response = await listaPrecioService.detalle_ExportarTipoImporteGanancia(row.id);
      if (response !== undefined)
        global.dowloadFile(response.data, "Reporte de Lista de Precio Importe Ganancia.xlsx");
    }
    else if (formValuesDetalle.idTipoListaPrecio === PRECIO_VENTA) {
      var response = await listaPrecioService.detalle_ExportarTipoPrecioVenta(row.id);
      if (response !== undefined)
        global.dowloadFile(response.data, "Reporte de Lista de Precio Tipo Precio Venta.xlsx");
    }

    this.setState({
      loadingdetalleExcel:false
    })
  };

  handleSave = (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?" + (values.id === 0 ? "" : " Los precios configurados se resetearán."), async () => {
      var response;

      if (values.id === 0)
        response = await listaPrecioService.registrar(values);
      else response = await listaPrecioService.modificar(values);

      if (response.status === 200) {
        form.resetFields();
        this.setState({ visible: false });
        message.success(
          (values.id === 0 ? "Registrado" : "Modificado") + " correctamente."
        );
        this._handlePagination(this.state.filter);
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleSaveConversionTipoPrecioVenta = (values, form) => {

    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response = await listaPrecioService.modificarDetalle(values);
      if (response.status === 200) {
        message.success("Modificado correctamente.");
        this.handleChildren(true, values.idProducto);
        form.resetFields();
        return;
      }

      if (response.status === 400) {
        dialog.warning(
          <ul>
            {response.data.messages.map((item) => (
              <li>{item}</li>
            ))}
          </ul>
        );
        return;
      }

      dialog.error(
        "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
      );
    });
  };

  handleChildren = async (expanded, id) => {
    if (!expanded) {
      return false;
    }
    var filter = new Object();
    filter.IdListaPrecio = this.state.formValuesDetalle.id;
    filter.IdProducto = id;
    var dataSource = [];

    var response = await listaPrecioService.listarDetalleLogisticaConversionPorTipoPrecioVenta(filter);

    if (response != undefined || response != null) {

      this.state.formValuesDetalle.detalle.forEach(element => {
        var item = { ...element };
        if (element.idProducto === id) {
          item.itemConversion = response;
        }
        dataSource.push(item);
      });

      this.setState({
        formValuesDetalle: {
          ...this.state.formValuesDetalle,
          detalle: dataSource
        }
      });
      return;
    }
  }


  handleNewCargaMasiva = async (row) => {

    var tipoCambio = await this.getTipoCambio();
    var params = auth.user().parametros;
    var precioUnitarioInclyIGV = params.filter((m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV)[0].valor === "1"
      ? true
      : false;
    var formValuesDetalle = this.fetchEmptyformValuesDetalle();
    formValuesDetalle.id = row.id;
    formValuesDetalle.tipoCambio = parseFloat(tipoCambio.venta);
    formValuesDetalle.tipoCambioCompra = parseFloat(tipoCambio.compra);
    formValuesDetalle.precioUnitarioInclyIGV = precioUnitarioInclyIGV;
    formValuesDetalle.tiposProductos = this.state.tiposProductos;
    formValuesDetalle.tipoListaPrecio = row.tipoListaPrecio;


    this.setState({
      visibleCargaMasiva: true,
      formValuesDetalle,
    });

  };

  handleDownloadFormatoCargaMasiva = async () => {
    var params = new Object();
    params.idListaPrecio = this.state.formValuesDetalle.id;
    params.idTipo = this.state.formValuesDetalle.idTipoProducto;
    params.tipoListaPrecio = this.state.formValuesDetalle.tipoListaPrecio;

    var response = await listaPrecioService.formatoCargaMasiva(params);
    if (response !== undefined)
      global.dowloadFile(response.data, "template-carga-masiva-lista-precio.xlsx");
  };

  handleSaveCargaMasiva = async (values, form) => {
    dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
      var response;

      response = await listaPrecioService.registrarCargaMasiva(values);

      if (response.status === 200) {
        var empty = this.fetchEmptyFormValues();
        this.setState({ visibleCargaMasiva: false, formValues: empty });
        form.setFieldsValue(empty);
        form.resetFields();

        message.success('Registrado correctamente.');

        this._handlePagination(this.state.filter);
        return;
      }

      if (response.status === 400) {
        dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
        return;
      }

      dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
    });
  };


  handleChangeCarga = (property, value) => {
    const formValuesDetalle = { ...this.state.formValuesDetalle, [property]: value };
    this.setState({ formValuesDetalle });
  };

  async componentDidMount() {
    this._initPagination(this.state.filter, listaPrecioService.paginacion);
    const monedas = await monedaService.listar();
    const tiposListaPrecio = await tipoListaPrecioService.listar();
    const establecimientos = await establecimientoService.principales();
    this.setState({
      monedas: monedas ? monedas : [],
      tiposListaPrecio: tiposListaPrecio ? tiposListaPrecio : [],
      establecimientos: establecimientos ? establecimientos : [],
      tiposProductos: [
        {
          id: 1,
          nombre: "Producto",
        },
        {
          id: 2,
          nombre: "Servicios",
        },
      ],
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Lista de Precio"
          onNew={this.handleNew}
          onSearch={() =>
            this._handlePagination({ ...this.state.filter, ...FILTER })
          }
          onClearFilters={this.handleClearFilters}
        />
        <Filters
          filter={this.state.filter}
          estados={this.state.estados}
          monedas={this.state.monedas}
          onKeyUpSearch={this.handleKeyUpInput}
          onChange={this.handleChange}
        />
        <ResultList
          pagination={this.state.pagination}
          loadingExcel={this.state.loadingExcel}
          loadingPdf={this.state.loadingPdf}
          loadingPrint={this.state.loadingPrint}
          loadingdetalleExcel={this.state.loadingdetalleExcel}
          onExportExcel={this.handleExportExcel}
          onExportPdf={this.handleExportPdf}
          onPrint={this.handlePrint}
          onEdit={this.handleEdit}
          onDetail={this.handleViewDetalle}
          onReplicar={this.handleReplicar}
          onDeleteActive={this.handleDeleteActive}
          onChange={this._handleChangePagination}
          onFile={this.handleNewCargaMasiva}
          onExportDetail={this.handleExcelDetalle}

        />
        <FormModal
          visible={this.state.visible}
          formValues={this.state.formValues}
          onChange={this.handleChangeForm}
          onClose={() => this.setState({ visible: false })}
          onSave={this.handleSave}
        />

        <VentaTipoPrecioVentaFormModal
          visible={this.state.visibleVentaTipoPrecioVenta}
          formValues={this.state.formValuesDetalle}
          onBuscarProducto={this.hanleBuscarProductoVentaTipoPrecioVenta}
          onEdit={this.handleEditVentaTipoPrecioVenta}
          onSave={this.handleSaveVentaTipoPrecioVenta}
          onClose={() => this.setState({ visibleVentaTipoPrecioVenta: false })}
        />

        <LogisticaTipoPrecioVentaModal
          visible={this.state.visibleLogisticaTipoPrecioVenta}
          formValues={this.state.formValuesDetalle}
          onBuscarProducto={this.hanleBuscarProductoLogisticaTipoPrecioVenta}
          onEdit={this.handleEditLogisticaTipoPrecioVenta}
          onSave={this.handleSaveLogisticaTipoPrecioVenta}
          onSaveExpand={this.handleSaveConversionTipoPrecioVenta}
          handleSearchExpand={this.handleChildren}
          onClose={() =>
            this.setState({ visibleLogisticaTipoPrecioVenta: false })
          }
        />

        <LogisticaTipoImporteGananciaFormModal
          visible={this.state.visibleLogisticaTipoImporteGanancia}
          formValues={this.state.formValuesDetalle}
          onBuscarProducto={this.hanleBuscarProductoLogisticaTipoImporteGanancia}
          onEdit={this.handleEditLogisticaTipoImporteGanancia}
          onSave={this.handleSaveLogisticaTipoImporteGanancia}
          onClose={() =>
            this.setState({ visibleLogisticaTipoImporteGanancia: false })
          }
        />

        <LogisticaTipoMargenComercialFormModal
          visible={this.state.visibleLogisticaTipoMargenComercial}
          formValues={this.state.formValuesDetalle}
          onBuscarProducto={this.hanleBuscarProductoLogisticaTipoMargenComercial}
          onEdit={this.handleEditLogisticaTipoMargenComercial}
          onSave={this.handleSaveLogisticaTipoMargenComercial}
          onClose={() =>
            this.setState({ visibleLogisticaTipoMargenComercial: false })
          }
        />

        <ReplicarPrecioModal
          visible={this.state.replicarVisible}
          formValues={this.state.replicarModal}
          onChangeRow={this.handleChangeSelectedRowKey}
          onSave={this.handleSaveReplicarPrecio}
          onCancel={() => this.setState({ replicarVisible: false })}
        />

        <CargaMasivaModal
          onDownloadFormatoCargaMasiva={this.handleDownloadFormatoCargaMasiva}
          onBuscarProducto={this.handleChangeCarga}
          visible={this.state.visibleCargaMasiva}
          formValues={this.state.formValuesDetalle}
          onUploadFile={listaPrecioService.subirCargaMasiva}
          onClose={() => this.setState({ visibleCargaMasiva: false })}
          onSave={this.handleSaveCargaMasiva}
        />
      </div>
    );
  }
}
